import UsedMachines from "@/pages/UsedMachines";

export default function NewMachines() {
  return <UsedMachines listingType="new" title="New Machines" noun="new machines" categoryType="machine" />;
}
